import React from 'react';

import { Button } from '@shared/components/bootstrap';
import { UserRole } from '@shared/types/user_role';

import {
  useConfirmation,
  Dialog as ConfirmationDialog,
  Response as ConfirmationResponse,
} from '@admin/components/confirmation';
import { Roles } from '@admin/components/helpers/roles';
import { client } from '@admin/libraries/apollo';
import { Barcode, Item, useItemDeactivateMutation } from '@admin/schema';

export const ItemDeactivateButton: React.FC<{
  item: Pick<Item, 'id' | 'active'> & { barcode: Pick<Barcode, 'id' | 'value'> };
}> = ({ item }) => {
  const { confirmation, confirm } = useConfirmation();

  const [execute, { loading }] = useItemDeactivateMutation({ client, variables: { id: item.id } });

  const onClick = async () => {
    const confirmed = await confirm({
      title: `Are you sure you want to delete #${item.barcode.value}?`,
      description: 'Deletion of items should only be used if the item was never in our possession.',
    });
    if (confirmed !== ConfirmationResponse.Confirm) return;

    await execute();
  };

  if (!item.active) return null;

  return (
    <Roles show={[UserRole.Admin, UserRole.DataCorrector]}>
      {confirmation && <ConfirmationDialog confirmation={confirmation} />}

      <Button loading={loading} kind="danger" type="button" onClick={onClick}>
        Delete
      </Button>
    </Roles>
  );
};
